import { Box, Chip, ChipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Chip)``;

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const EndIconBox = styled(Box)<{
  size: ChipProps['size'];
  color: ChipProps['color'];
}>(({ theme, size, color }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: color
    ? // @ts-ignore
      theme.palette[color][100]
    : theme.palette.grey[100],
  height:
    size === 'small'
      ? theme.spacing(2)
      : size === 'medium'
      ? theme.spacing(2.25)
      : theme.spacing(1),
  width:
    size === 'small'
      ? theme.spacing(2)
      : size === 'medium'
      ? theme.spacing(2.25)
      : theme.spacing(1),
  aspectRatio: 1,
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
}));
